import styled from 'styled-components';
import { COLORS, POSITIONING } from '../../constants';

interface ChatHeaderContainerProps {
  $chatInterfaceActive?: boolean;
  $twilioDisconnected?: boolean;
}

const ChatHeaderContainer = styled.div<ChatHeaderContainerProps>`
  width: 100%;
  height: ${POSITIONING.HEADER_HEIGHT};
  background: ${COLORS.DARK_BLUE};
  border-radius: 4px 4px 0 0;
  display: flex;
  padding: 0 10px;
  align-items: center;
  pointer-events: all;
  cursor: ${({ $chatInterfaceActive, $twilioDisconnected }) => {
    if ($twilioDisconnected) return 'wait';
    if ($chatInterfaceActive) return 'initial';
    return 'pointer';
  }}
`;

export default ChatHeaderContainer;
